module.exports = __webpack_public_path__ + "static/media/5.a655b4ab.png";